module.exports = __webpack_public_path__ + "assets/img/photo-2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonials/photo-2.jpg
// module id = 1990
// module chunks = 0